import { render } from "./locationTarget.vue?vue&type=template&id=fc492b5c"
import script from "./locationTarget.vue?vue&type=script&lang=js"
export * from "./locationTarget.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__